import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { t } from '../i18n';

export default function MagicLinkCallbackPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const handleMagicLinkCallback = async () => {
      const token = searchParams.get('token');
      const error = searchParams.get('error');

      if (error) {
        console.error('Magic link error:', error);
        navigate('/login?error=magic_link_failed');
        return;
      }

      if (token) {
        try {
          // Use the magic login endpoint
          const response = await fetch(`/api/auth/magic/callback?token=${token}`);
          const data = await response.json();

          if (response.ok) {
            // Store the token and update auth state
            localStorage.setItem('match-a_token', data.token);
            window.location.href = '/dashboard'; // Force full page reload to update auth state
          } else {
            throw new Error(data.error || 'Magic link login failed');
          }
        } catch (err) {
          console.error('Magic link callback error:', err);
          navigate('/login?error=magic_link_failed');
        }
      } else {
        navigate('/login?error=magic_link_failed');
      }
    };

    handleMagicLinkCallback();
  }, [navigate, searchParams]);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #f0fdf4 0%, #fafdf5 60%, #dcfce7 100%)'
    }}>
      <div className="card" style={{ padding: 40, textAlign: 'center', maxWidth: 400 }}>
        <div style={{ fontSize: 48, marginBottom: 20 }}>🔗</div>
        <h2 style={{ fontSize: 24, marginBottom: 16 }}>{t('magicLinkVerifying')}</h2>
        <p style={{ color: 'var(--text-muted)' }}>
          {t('magicLinkVerifying')}
        </p>
      </div>
    </div>
  );
}